import { useMutation } from '@tanstack/react-query';
import { stubLookup } from '@/lib/parts-financial/stubLookup';
import type { TaxLookupAddress, TaxLookupResult } from '@/lib/parts-financial/taxLookup';

/** Phase 1 lookup hook — uses the deterministic stub. */
export function useTaxLookupStub() {
  return useMutation<TaxLookupResult, Error, TaxLookupAddress>({
    mutationFn: (addr) => stubLookup(addr),
  });
}
